export default "__VITE_ASSET__2a68a4d4__"